"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getMasterManifestUrl;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _webUtils = require("@tunein/web-utils");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isBoolean = _interopRequireDefault(require("lodash/isBoolean"));
var _tuner = _interopRequireDefault(require("../tuner"));
var _debugger = _interopRequireDefault(require("../debugger"));
var _handleInstreamError = _interopRequireDefault(require("../player/utils/handleInstreamError"));
var _getAdswizzListenerId = _interopRequireDefault(require("./getAdswizzListenerId"));
var _logging = require("../player/constants/logging");
var _parseQuery2 = _interopRequireDefault(require("./parseQuery"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// eslint-disable-next-line consistent-return
function getMasterManifestUrl(_x) {
  return _getMasterManifestUrl.apply(this, arguments);
}
function _getMasterManifestUrl() {
  _getMasterManifestUrl = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(requestUrl) {
    var _tuner$streamPlayer$g, timeout, host, _get, palNonce, ppid, gdprTcString, gdprApplies, isOptedOut, isOptedOutOfCcpaOrGlobal, isUserInUS, _get$dfpParams, dfpParams, adsParams, _parseQuery, language, adswizzListenerId, _yield$fetchWithRetry, manifestUrl, trackingUrl;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _debugger["default"].log('attempting to fetch master manifest url', requestUrl);
          _context.prev = 1;
          _tuner$streamPlayer$g = _tuner["default"].streamPlayer.getPlayerConfig(), timeout = _tuner$streamPlayer$g.timeout;
          host = requestUrl.substring(0, requestUrl.indexOf('/v1'));
          _get = (0, _get2["default"])(_tuner["default"], 'tune.params', {}), palNonce = _get.palNonce, ppid = _get.ppid, gdprTcString = _get.gdprTcString, gdprApplies = _get.gdprApplies, isOptedOut = _get.isOptedOut, isOptedOutOfCcpaOrGlobal = _get.isOptedOutOfCcpaOrGlobal, isUserInUS = _get.isUserInUS, _get$dfpParams = _get.dfpParams, dfpParams = _get$dfpParams === void 0 ? {} : _get$dfpParams; // IMPORTANT: ADS PARAMS ATTRIBUTES MUST BE STRINGS
          // see https://docs.google.com/document/d/1J2XU_0TN5Ix_vLdcuJd-h6vdHdPQvc2wc8fSLNu3ojA
          _context.t0 = _objectSpread;
          _context.next = 8;
          return _tuner["default"].instreamCustParamsPromise;
        case 8:
          _context.t1 = _context.sent;
          if (_context.t1) {
            _context.next = 11;
            break;
          }
          _context.t1 = '';
        case 11:
          _context.t2 = _context.t1;
          _context.t3 = (0, _get2["default"])(_tuner["default"], 'bundleId') || '';
          _context.t4 = (0, _get2["default"])(_tuner["default"], 'adsPartnerAlias') || '';
          _context.t5 = {
            ciu_szs: '300x250,728x90',
            gdfp_req: '1',
            cust_params: _context.t2,
            bundleid: _context.t3,
            iu: _context.t4
          };
          _context.t6 = dfpParams;
          adsParams = (0, _context.t0)(_context.t5, _context.t6);
          _parseQuery = (0, _parseQuery2["default"])(adsParams.cust_params), language = _parseQuery.language;
          if (language) {
            adsParams.hl = language;
          }
          if (palNonce) {
            adsParams.paln = palNonce;
          }

          // gdprApplies can be undefined until OneTrust determines whether GDPR applies
          if ((0, _isBoolean["default"])(gdprApplies)) {
            // IMPORTANT: ADS PARAMS ATTRIBUTES MUST BE STRINGS
            adsParams.gdpr = gdprApplies ? '1' : '0';
          }
          if (gdprApplies) {
            // IMPORTANT: ADS PARAMS ATTRIBUTES MUST BE STRINGS
            adsParams.npa = isOptedOut ? '1' : '0'; // 0 for personalized ads, 1 for non-personalized ads
          }
          if (gdprApplies && gdprTcString) {
            adsParams.gdpr_consent = gdprTcString;
          }
          if (ppid) {
            adsParams.ppid = ppid;
          }
          if (isUserInUS) {
            adsParams.rdp = isOptedOutOfCcpaOrGlobal ? '1' : '0';
          }
          adswizzListenerId = (0, _getAdswizzListenerId["default"])();
          if (adswizzListenerId) {
            adsParams.rdid = adswizzListenerId;
            adsParams.idtype = 'adid';
          }
          _context.next = 29;
          return (0, _webUtils.fetchWithRetry)(requestUrl, {
            post: {
              adsParams: adsParams
            },
            bailTimeout: timeout
          });
        case 29:
          _yield$fetchWithRetry = _context.sent;
          manifestUrl = _yield$fetchWithRetry.manifestUrl;
          trackingUrl = _yield$fetchWithRetry.trackingUrl;
          if (!manifestUrl) {
            _context.next = 34;
            break;
          }
          return _context.abrupt("return", {
            trackingUrl: trackingUrl && "".concat(host).concat(trackingUrl),
            manifestUrl: "".concat(host).concat(manifestUrl)
          });
        case 34:
          throw new Error('manifestUrl missing from response');
        case 37:
          _context.prev = 37;
          _context.t7 = _context["catch"](1);
          _debugger["default"].log("Fetching master manifest url: ".concat(_context.t7.message), _context.t7);
          (0, _handleInstreamError["default"])(_context.t7, _logging.actions.instreamPostTimeout, _logging.actions.instreamPostError, true);
          throw new Error("Fetching master manifest url: ".concat(_context.t7.message));
        case 42:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 37]]);
  }));
  return _getMasterManifestUrl.apply(this, arguments);
}
//# sourceMappingURL=getMasterManifestUrl.js.map